export var IP =
         process.env.NODE_ENV === "development"
           ? "http://127.0.0.1:3033" //本地代理
           : "https://niaojian.bboycc.cn";